// Partenaire Reducer
const partenaireChargedDefaultState = {
	id: "",
	host: "",
	nom: "",
	telephone: "",
	idFichierLogo: null,
	logo64: null,
    logoName: "",
    urlOneTrust: "",
    marqueAllianzPartners: "",
    marqueLogo64: null,
    marqueLogoFile: "",
    favicon64: null
};

export default (state = partenaireChargedDefaultState, action) => {
  switch (action.type) {
      case 'SET_PARTENAIRE':
          return {
              ...state,
              id: action.data.data.id,
              host: action.data.data.host,
              nom: action.data.data.nom,
              idFichierLogo: action.data.data.idFichierLogo,
              telephone: action.data.data.telephone,
              logo64: action.data.partenaireLogo != null ? action.data.partenaireLogo.base64: '',
              logoName: action.data.data.partenaireLogo != null ? action.data.data.partenaireLogo.filename: '',
              urlOneTrust: action.data.data.urlOneTrust != null ? action.data.data.urlOneTrust: '',
              marqueAllianzPartners: action.data.data.marqueAllianzPartners != null && action.data.data.marqueAllianzPartners != '' ? action.data.data.marqueAllianzPartners: 'Mondial Assistance',
              marqueLogo64: action.data.partenaireMarque != null ? action.data.partenaireMarque.base64 : null,
              marqueLogoFile: action.data.partenaireMarque != null ? action.data.partenaireMarque.filename : "",
              favicon64: action.data.partenaireFavicon != null ? action.data.partenaireFavicon.base64 : null
          };
      default:
          return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/partenaire.js